import React from "react";
import { RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI crash", error, info?.componentStack); }
  componentDidUpdate(prev) { if (this.state.error && prev.location !== this.props.location) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error).slice(0, 200);
    return (
      <div data-testid="ui-error" className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="max-w-sm w-full bg-white border border-red-200 rounded-2xl p-5 text-center">
          <p className="font-display font-bold text-base mb-1">Algo correu mal ao mostrar esta página</p>
          <p className="text-xs text-zinc-500 mb-1">Os teus dados não foram afectados.</p>
          <p className="text-[10px] text-zinc-400 break-words mb-4" data-testid="ui-error-detail">{msg}</p>
          <div className="flex gap-2">
            <button data-testid="ui-error-retry" onClick={() => this.setState({ error: null })} className="flex-1 py-2.5 rounded-xl bg-black text-white text-xs font-semibold inline-flex items-center justify-center gap-1"><RefreshCw size={12} /> Tentar novamente</button>
            <button data-testid="ui-error-reload" onClick={() => window.location.reload()} className="flex-1 py-2.5 rounded-xl border border-zinc-300 text-xs font-semibold">Recarregar</button>
          </div>
        </div>
      </div>
    );
  }
}
